import Menu from 'Models/Menu';

export default [
  Menu.chemicalInformation,
  Menu.createNewChemical,
  Menu.chemicalAddNotes,
  Menu.chemicalHelp,
];
